<app-header></app-header> 

<!-- Page title section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg')">
    <div class="bg-dark-05">
        <div class="container text-center z-index-1">
            <h1 class="fw-bold uppercase letter-spacing-1 m-0">Our Team</h1>
        </div><!-- end container -->
    </div>
</div>
<!-- end Page title section -->

<!-- Team section -->
<div class="section border-top">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h6 class="d-inline-block bg-gray border-radius px-3 py-2 line-height-140 font-small uppercase letter-spacing-1 mb-3"><span class="text-gradient-1">Our Team</span></h6>
                <h2 class="fw-semi-bold mb-0 text-capitalize animate-text">Designing Experiences That Inspire.</h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 gy-5 team-wrapper border-radius mt-4">
            <div class="col-12 col-sm-6 col-lg-3 team-box img-class" *ngFor="let member of teamMembers">
                <div class="team-img">
                    <img [src]="member.img" [alt]="member.alt">
                    <!-- social links -->
                    <div>
                        <ul>
                        <li *ngFor="let social of member.socials">
                            <a [href]="social.link">
                            <i class="bi" [ngClass]="social.icon"></i>
                            </a>
                        </li>
                        </ul>
                    </div>
                </div>
                <h5 class="fw-medium m-0">{{ member.name }}</h5>
                <p class="text-gradient-1">{{ member.role }}</p>
            </div>
        </div>
    </div><!-- end container -->
</div>
<!-- end Team section -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-3.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
                <i class="bi bi-play"></i>
            </a>
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Features section -->
<div class="section-lg">
    <div class="container icon-5xl">
        <div class="row g-4">
            <div class="col-12 col-lg-4 img-class" *ngFor="let feature of features">
                <div class="bg-white border-radius-1 box-shadow hover-float p-4 p-xl-5">
                    <div class="text-gradient-1 mb-2 mb-lg-3">
                        <i class="bi" [ngClass]="feature.icon"></i>
                    </div>
                    <h5 class="fw-medium">
                        {{ feature.title }}
                    </h5>
                    <p>
                        {{ feature.description }}
                    </p>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Features section -->

<!-- Sliding Text -->
<section class="section-sm pt-0">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->

<!-- Testimonial section -->
<div class="section pt-0">
    <div class="container">
        <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr testimonial-inner mrt-80">
          <ng-template carouselSlide *ngFor="let slide of slideStore">
            <!-- Testimonial box -->
            <div class="testimonial-box">
              <img class="mb-3" src="assets/images/testimonials/{{slide.image}}" alt="client-img">
              <h5 class="fw-normal line-height-140 m-0">{{slide.title}}</h5>
              <span class="font-small fw-normal">{{slide.subtitle}}</span>
              <p class="mt-3">{{slide.desc}}</p>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div><!-- end container -->
<!-- end Testimonial section -->